import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';

import { provideClientHydration } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideClientHydration(),
  ],
};
